/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
==========================================================================================*/
const state = {
    loading: true,
    pageLoader: false,
    shopLoader: false,

    error_message: false,
    success_message: false,
    message_type: false,
    frontend_notify: {
      title: false,
      text: false,
      type: false
    },

    status: '',

    permissions: false,

    token: localStorage.getItem('access-token') || '',
    user_id: localStorage.getItem('user_id') || null,

    primary_color: localStorage.getItem('primary_color') || null,

    local_active_language_id: null,

    firstFrontLoad: false,

    user: {},
    profile: {},
    notification_settings: {},
    profileImage: null,
    profileImage_b: null,
    profileImage_s: null,
    coverImage: null,
    coverImage_b: null,
    coverImage_m: null,
    coverImage_s: null,
    organization_name: false,
    organization: {},
    activeLanguage: {},
    sidebarMenuAdminName: '',
    sidebarMenuAdmin: [],
    profileMenu: [],
    languageMenu: [],
    searchable: [],
    staredPages: [],

    cartProductCount: 0,
    cart: null,
    activeOrder: null,

    languages: [],
    countries: [],

    users: null,
    usersCount: null,

    pages: null,

    APP_NAME: "WD Commerce",
    APP_URL: process.env.NODE_ENV === 'production' ? process.env.MIX_PROD_APP_URL : process.env.MIX_DEV_APP_URL,
    API_URL: process.env.NODE_ENV === 'production' ? process.env.MIX_PROD_API_URL : process.env.MIX_DEV_API_URL,

    page: null,
    title: null,

    // ////////////////////////////////////////////
    // SIDEBAR & UI UX
    // ////////////////////////////////////////////

    themeSettings: {

        default: {
            theme: 'semi-dark'
        },
        new: {}
    },
    basicOrganizationData: {
        logo: '/images/logos/logo.png',
        logo_b: '/images/logos/logo_b.png',
        logo_s: '/images/logos/logo_s.png',
        logo_big: '/images/logos/logo_big.png',
        logo_big_b: '/images/logos/logo_big_b.png',
        logo_big_s: '/images/logos/logo_big_s.png',
    },
    currentTranslations: false,

    confirmType: false,
    confirmEmail: false,
    confirmToken: false,


    isSidebarActive: true,
    breakpoint: null,
    sidebarWidth: "default",
    bodyOverlay: false,
    sidebarItemsMin: false,
    theme: {
        primary_color: '#6A50A2',
        mode: 'semi-dark',
        nav_bar_color: "#6A50A2",
        nav_bar_type: "sticky",
        animation: 'zoom-fade',
        sidebar_collapsed: false,
        show_customizer: true,
    },

    defaultTheme: {
        primary_color: '#6A50A2',
        mode: 'light',
        nav_bar_color: "#6A50A2",
        nav_bar_type: "sticky",
        animation: 'zoom-fade',
        sidebar_collapsed: false,
        show_customizer: true,
    },

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar component
    windowWidth: null,
    tmpStatisticsLayoutBlocks: [
        {
            "i": 4,
            "block": 16,
            "w": 12,
            "h": 10,
            "minW": 2,
            "maxW": 12,
            "minH": 15,
            "maxH": 20,
            "title": "Activity Timeline"
        },
        { "i": 1, "block": 10, "w": 4, "h": 12, "minW": 2, "maxW": 12, "minH": 12, "maxH": 20, "title": "Profit" },
        {
            "i": 2,
            "block": 14,
            "w": 4,
            "h": 15,
            "minW": 2,
            "maxW": 12,
            "minH": 13,
            "maxH": 20,
            "title": "Product Orders"
        },
        { "i": 3, "block": 15, "w": 4, "h": 15, "minW": 2, "maxW": 12, "minH": 13, "maxH": 20, "title": "Sales Stats" },
    ],

    statisticsLayoutBlocks: [
        {
            "i": 4,
            "block": 16,
            "w": 12,
            "h": 10,
            "minW": 2,
            "maxW": 12,
            "minH": 15,
            "maxH": 20,
            "title": "Activity Timeline"
        },
        { "i": 1, "block": 10, "w": 4, "h": 15, "minW": 2, "maxW": 12, "minH": 12, "maxH": 20, "title": "Profit" },
        {
            "i": 2,
            "block": 14,
            "w": 4,
            "h": 15,
            "minW": 2,
            "maxW": 12,
            "minH": 13,
            "maxH": 20,
            "title": "Product Orders"
        },
        { "i": 3, "block": 15, "w": 4, "h": 15, "minW": 2, "maxW": 12, "minH": 13, "maxH": 20, "title": "Sales Stats" },
    ],
    newsFeeds: {
        feeds: [],
        nextPageLink: undefined,
        commentsNextPageLinks: {},
        totalCommentsCountPerFeed: {},
        toPageCommentsCountPerFeed: {},
        feedLikes: [],
        commentLikes: []
    },
    focusCommentInputId: 0
};

export default state
